module.exports = __webpack_public_path__ + "static/media/illustrator.8cd996ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/illustrator.png
// module id = 2557
// module chunks = 0